import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class UniversityApi {
  addUniversity(data, config) {
    return axios.post(BASE_URL + "/admin/university/create", data, config)
  }

  updateUniversity(data, config) {
    return axios.put(BASE_URL + "/admin/university/update", data, config)
  }

  getAllUniversity(config) {
    return axios.get(BASE_URL + "/admin/university/universityDetails", config)
  }

  getUniversityById(id, config) {
    return axios.get(
      `${BASE_URL}/admin/university/universityByCode/${id}`,
      config,
    )
  }

  getUniversityMenuList(config) {
    return axios.get(BASE_URL + "/admin/university/universityMenuList", config)
  }

  getCollegesByUniversity(universityCode, config) {
    return axios.get(
      BASE_URL +
        `/admin/university/institueDetailsByUniversity/${universityCode}`,
      config,
    )
  }

  uploadUniversityByExcel(data, config) {
    return axios.post(
      BASE_URL + "/admin/university/uploaduniversity",
      data,
      config,
    )
  }

 updateUniversityStatus(payload, config) {
    return axios.put(
      BASE_URL + "/admin/university/update-status",
      payload,
      config,
    )
  }


}

const universityApi = new UniversityApi()
export default universityApi
